// @noflow
import PropTypes from 'prop-types';
import * as React from 'react';
import { textAnchor } from '../../../../constants';

const { START } = textAnchor;
const X_TICK_HEIGHT = 10;
const X_LABEL_Y_OFFSET = 20;
const textMergeMargin = 5;

const getSVGTextLength = ({ label, style }) => {
    if (label && document && document.createElementNS) {
        const text = document.createElementNS('SVG', 'text');
        const textNode = document.createTextNode(label);
        text.appendChild(textNode);
        text.setAttribute('style', style);
        document.body.appendChild(text);
        const textWidth = text.getBoundingClientRect().width;
        document.body.removeChild(text);
        return textWidth;
    }
    return 0;
};

export default function AxisXTicks({ barChartData, compHeight, compWidth, axisStyles, margin, xDomain }) {
    const { axisColour, fontColour, fontFamily, fontSize } = axisStyles;
    const lineStyle = { stroke: axisColour };
    const textStyle = {
        fontFamily,
        fontSize,
        stroke: fontColour,
        textAnchor: START
    };
    const y1 = compHeight - margin.bottom;
    const y2 = y1 + X_TICK_HEIGHT;
    const y2Halved = y1 + X_TICK_HEIGHT / 2;
    const labelY = y2 + X_LABEL_Y_OFFSET;
    const ticks = [];
    const dataLength = barChartData.length;
    if (dataLength) {
        const textWidth =
            getSVGTextLength({
                label: barChartData[0].labelX,
                style: textStyle
            }) + textMergeMargin;
        let lastLabelXPos = 0;

        barChartData.forEach((data, i) => {
            const x = data.x;
            const labelX = data.labelX || data[xDomain];
            const showLabel = x > lastLabelXPos;
            lastLabelXPos = showLabel ? x + textWidth : lastLabelXPos;

            ticks.push(
                <g key={`xTick-${labelX}-${i}`} name="xTick">
                    <line style={lineStyle} x1={x} x2={x} y1={y1} y2={showLabel ? y2 : y2Halved} />
                    {showLabel && (
                        <text style={textStyle} x={x} y={labelY}>
                            {labelX}
                        </text>
                    )}
                </g>
            );
        });
        /// Adding a last tick at the end
        const lastTickX = compWidth - margin.right;
        ticks.push(
            <g key="xTick-last" name="xTick">
                <line style={lineStyle} x1={lastTickX} x2={lastTickX} y1={y1} y2={y2} />
            </g>
        );
    }

    return <g name="xTicks">{ticks}</g>;
}

AxisXTicks.propTypes = {
    axisStyles: PropTypes.shape({
        axisColour: PropTypes.string.isRequired,
        fontColour: PropTypes.string.isRequired,
        fontFamily: PropTypes.string.isRequired,
        fontSize: PropTypes.string.isRequired
    }),
    barChartData: PropTypes.arrayOf(
        PropTypes.shape({
            labelX: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            width: PropTypes.number.isRequired,
            x: PropTypes.number.isRequired
        })
    ).isRequired,
    compHeight: PropTypes.number.isRequired,
    compWidth: PropTypes.number.isRequired,
    margin: PropTypes.shape({
        top: PropTypes.number.isRequired,
        left: PropTypes.number.isRequired,
        bottom: PropTypes.number.isRequired,
        right: PropTypes.number.isRequired
    }),
    xDomain: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/graph/axis/axisX/xTicks/index.js